import { ShoppingBag } from "lucide-react";
import { useCart, useSiteCart } from "@/features/commerce/cart";
import { cn } from "@/lib/cn";
import { t } from "@/i18n/id";

/** Header cart. Empty stays a quiet icon; with items it becomes a pay pill so the count never floats over the avatar. */
export function CartButton({ siteId }: { siteId: string }) {
  const items = useSiteCart(siteId);
  const open = useCart((s) => s.open);
  const n = items.length;
  return (
    <button
      type="button"
      onClick={() => open(siteId)}
      aria-label={n ? t.cart.count(n) : t.cart.open}
      title={t.cart.title}
      className={cn(
        "inline-flex h-10 shrink-0 items-center justify-center rounded-full font-semibold transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary",
        n ? "gap-1.5 bg-primary pl-3 pr-1.5 text-white shadow-button hover:bg-primary-hover" : "size-10 text-slate-600 hover:bg-slate-100",
      )}
    >
      <ShoppingBag className="size-4" aria-hidden="true" />
      {n ? (
        <>
          <span className="hidden text-sm sm:inline">{t.cart.short}</span>
          <span className="grid h-7 min-w-7 place-items-center rounded-full bg-white px-1.5 text-xs font-bold tabular-nums text-primary">{n}</span>
        </>
      ) : null}
    </button>
  );
}
